module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstateOpenArrow-135edd4c486dee11a9a90377304d4f3b.svg";